import React from 'react';
import PropTypes from 'prop-types';

import {
  BulkUnassignTasksDialogContent,
  TaskAssignmentBulkActionDialogFooter
} from './components';
import {
  useBulkUnassignTasksSubmit,
  usePreviewBulkUnassignTasksToResourceUser
} from './hooks';

const BulkUnassignTasksDialogBody = ({
  assignedTasksCount,
  dialogDescribedById,
  resource,
  projectId,
  textSearch,
  resetTaskAssignments,
  onTaskAssignmentUpdateSuccess,
  onClose,
  isRmpTaskAllocationEnhancement1
}) => {
  const {
    isBulkUnassignTasksInProgress,
    handleBulkUnassignTasksSubmit
  } = useBulkUnassignTasksSubmit({
    projectId,
    resource,
    textSearch,
    resetTaskAssignments,
    onTaskAssignmentUpdateSuccess,
    onClose,
    isRmpTaskAllocationEnhancement1
  });

  const {
    hasTaskResourceAllocation,
    isLoading
  } = usePreviewBulkUnassignTasksToResourceUser({
    projectId,
    resourceUserId: resource.id,
    textSearch
  });

  return (
    <>
      <BulkUnassignTasksDialogContent
        assignedTasksCount={assignedTasksCount}
        dialogDescribedById={dialogDescribedById}
        hasTaskResourceAllocation={hasTaskResourceAllocation}
        isBulkUnassignTasksInProgress={isBulkUnassignTasksInProgress}
        isLoading={isLoading}
        resourceUserName={resource.displayText}
      />
      <TaskAssignmentBulkActionDialogFooter
        onClose={onClose}
        onSubmit={handleBulkUnassignTasksSubmit}
        isBulkActionInProgress={isBulkUnassignTasksInProgress}
        confirmButtonTextId="taskAssignmentBulkActionDialog.removeAllTasksAssignments"
        confirmButtonColor="secondary"
        isLoading={isLoading}
      />
    </>
  );
};

BulkUnassignTasksDialogBody.propTypes = {
  assignedTasksCount: PropTypes.number,
  dialogDescribedById: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  resource: PropTypes.object.isRequired,
  projectId: PropTypes.string.isRequired,
  textSearch: PropTypes.string,
  resetTaskAssignments: PropTypes.func.isRequired,
  onTaskAssignmentUpdateSuccess: PropTypes.func.isRequired,
  isRmpTaskAllocationEnhancement1: PropTypes.bool.isRequired
};

export default BulkUnassignTasksDialogBody;
